import { useEffect } from 'react';
import Modal from 'react-modal';
import { Tooltip as ReactTooltip } from 'react-tooltip';

const ModalComponent = (props) => {
  const {
    children,
    isOpen,
    setIsOpen,
    maxWidth = 700,
    height = 'auto',
    onAfterClose = () => {},
    overlayClassName = 'react-modal-overlay',
    shouldCloseOnOverlayClick = true,
    style = {},
    additionalOpenAction,
    className = '',
    closeFunctionality,
    notShowCloseButton,
    onOverlayMouseDown,
  } = props;

  const closeModal = (event) => {
    event?.stopPropagation?.();
    setIsOpen(false);
  };

  const overlayElement = (props, contentElement) => {
    const { onMouseDown, onClick, ...rest } = props;

    return (
      <div
        {...rest}
        onMouseDown={(event) => {
          // content is a DOM descendant of the overlay, so this fires for every click inside the
          // modal, not just the backdrop - only treat it as an overlay click when the click actually
          // landed on the overlay itself (same check used below for shouldCloseOnOverlayClick),
          // otherwise a normal click into a field would spuriously trigger this too.
          if (event.target === event.currentTarget) {
            // Runs before react-modal's own overlay mousedown handling (and before the resulting
            // click), so a caller can inspect/react to state as it was right when the click started.
            onOverlayMouseDown?.(event);
          }
          event.stopPropagation();
          if (shouldCloseOnOverlayClick && event.target === event.currentTarget) {
            event.preventDefault();
          }
          onMouseDown?.(event);
        }}
        onClick={(event) => {
          event.stopPropagation();
          onClick?.(event);
        }}
      >
        {contentElement}
      </div>
    );
  };

  useEffect(() => {
    if (isOpen && additionalOpenAction) {
      additionalOpenAction();
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      // 0 in tests: react-modal schedules removePortal via a real setTimeout when a modal unmounts
      // while open, which can fire after Vitest tears down jsdom and throw "document is not defined".
      closeTimeoutMS={import.meta.env.MODE === 'test' ? 0 : 300}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      overlayClassName={overlayClassName}
      className={`react-modal-content modal-slide-text ${className}`}
      onRequestClose={closeModal}
      overlayElement={overlayElement}
      shouldFocusAfterRender={true}
      style={{
        content: {
          width: '90%',
          maxWidth: `${maxWidth}px`,
          height,
          ...style,
        },
      }}
      onAfterClose={onAfterClose}
    >
      {isOpen && !notShowCloseButton && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (closeFunctionality) {
              closeFunctionality();
            } else {
              setIsOpen(false);
            }
          }}
          className='circle-button general-button hovered-button modal-close-button z-max action-state-hover'
        >
          <span className='icon-close paragraph-p5' />
        </button>
      )}
      {children}
      <ReactTooltip
        effect={'solid'}
        id={'modal-tooltip'}
        className={'header-tooltip'}
        arrowColor={'transparent'}
        place={'top'}
      />
    </Modal>
  );
};

export default ModalComponent;
